import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showErrors(event) {
    event.preventDefault()

    const dialogId = event.params.dialog
    if (!dialogId) return

    const dialog = document.getElementById(dialogId)
    if (dialog) {
      dialog.showModal()
    }
  }

  closeDialog(event) {
    event.preventDefault()

    const dialogId = event.params.dialog
    if (!dialogId) return

    const dialog = document.getElementById(dialogId)
    if (dialog) {
      dialog.close()
    }
  }

  backdropClick(event) {
    // Close when clicking the backdrop (the dialog element itself, not its children)
    if (event.target.tagName === "DIALOG") {
      event.target.close()
    }
  }
}
